module.exports = __webpack_public_path__ + "img/activities-1.5f1b1607.jpg";